const SobreNosotros = () => {

  return (
    <section className="sobre-nosotros revelar">
        <div className="descripcion-container">
            <div className="descripcion-texto">
                    <h2>Pasión por el Hierro y la Precisión</h2>
                    <p>En <strong>Herrería Vader</strong>, transformamos el metal en soluciones duraderas para tu hogar o empresa...</p>
                <div className="puntos-clave">
                    <span><i className="fas fa-check"></i> Diseños a medida</span>
                            <span><i className="fas fa-check"></i> Materiales de primera</span>
                    <span><i className="fas fa-check"></i> Atención personalizada</span>
                </div>
            </div>
        </div>
    </section>
  );
};

export default SobreNosotros;